import {
  Component,
  inject,
  input,
  InputSignal,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToFontSizePipe } from '../../../../pipes/to-font-size/to-font-size.pipe';
import {
  DEFAULT_PAYMENT_PROVIDERS,
  EFooterBlockType,
  ERelationType,
  IFooterBlock,
  IFooterPaymentProvider,
} from '@web/dtos';
import { LanguagePipe } from '../../../../pipes/language/language.pipe';
import { FilterTextsPipe } from '../../../../pipes/filterTexts/filterTexts.pipe';
import { FooterStore } from '../../../../services/api/footer/footer-store.service';
import { PaymentProviderStore } from '../../../../services/api/payment-provider/payment-provider-store.service';
import { QuillViewComponent } from 'ngx-quill';

@Component({
  selector: 'aw-footer-block',
  imports: [
    CommonModule,
    ToFontSizePipe,
    LanguagePipe,
    FilterTextsPipe,
    QuillViewComponent,
  ],
  templateUrl: './footer-block.component.html',
})
export class FooterBlockComponent {
  public readonly name: InputSignal<string | undefined> = input<string>();
  public readonly headline: InputSignal<string | undefined> = input<string>();
  public readonly headlineSize: InputSignal<number | undefined> =
    input<number>();
  public readonly showHeadline: InputSignal<boolean> = input<boolean>(true);
  public readonly children: InputSignal<TemplateRef<unknown> | undefined> =
    input<TemplateRef<unknown>>();
  public readonly block: InputSignal<IFooterBlock | undefined> =
    input<IFooterBlock>();
  public readonly paymentProviders: InputSignal<
    IFooterPaymentProvider[] | undefined
  > = input<IFooterPaymentProvider[]>();
  protected readonly footerStore: FooterStore = inject(FooterStore);
  protected readonly paymentProviderStore: PaymentProviderStore =
    inject(PaymentProviderStore);
  protected readonly FooterBlockType: typeof EFooterBlockType =
    EFooterBlockType;
  protected readonly RelationType: typeof ERelationType = ERelationType;

  protected visiblePaymentProviders() {
    const configured = this.paymentProviders();
    const providers = configured?.length
      ? configured
      : DEFAULT_PAYMENT_PROVIDERS.map(provider => ({
          providerId: provider.id!,
          visible: false,
          description: [],
          url: '',
        }));
    return providers
      .filter(provider => provider.visible)
      .map(provider => ({
        ...provider,
        name:
          DEFAULT_PAYMENT_PROVIDERS.find(
            item => item.id === provider.providerId
          )?.filename ?? '',
      }));
  }
}
